// extracted by mini-css-extract-plugin
export var container = "_36-0";
export var error = "_36-9";
export var label = "_36-5";
export var light = "_36-6";
export var md = "_36-3";
export var sm = "_36-2";
export var thin = "_36-8";
export var thinBold = "_36-7";
export var vertical = "_36-4";
export var xs = "_36-1";